import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import DocumentTitle from 'react-document-title'
import {Link} from 'react-router-dom'
import {Form, Input, Button, Alert} from 'antd'

import style from './login.sass'

@inject('store') @observer
class Login extends Component {
  calculateHeight = () => {
    let footerHeight = 0
    const footer = document.querySelector('footer')
    if (footer) {
      footerHeight = footer.getBoundingClientRect().height
    }
    return window.innerHeight - footerHeight
  }
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.auth.change(name, value)
  }
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.store.auth.login()
  }
  render() {
    const {email, password, error, loading, validationErrors} = this.props.store.auth
    return(
      <div style={{height:this.calculateHeight()}} styleName='wrapper'>
        <DocumentTitle title='Login'/>
        <div styleName='banner'/>

        <div styleName='card'>
          <h2>Login to Algoriz</h2>
          <p>Don&apos;t have an account? <Link to='/signup'>Sign up</Link></p>
          {error && <Alert message={error} type='error' styleName='alert'/>}
          <Form onSubmit={this.handleSubmit}>
            <Form.Item
              validateStatus={validationErrors.email ? 'error' : null}
              help={validationErrors.email}
            >
              <Input
                size='large'
                type='email'
                name='email'
                placeholder='Email'
                value={email}
                onChange={this.handleChange}
              />
            </Form.Item>
            <Form.Item
              validateStatus={validationErrors.password ? 'error' : null}
              help={validationErrors.password}
            >
              <Input
                size='large'
                type='password'
                name='password'
                placeholder='Password'
                value={password}
                onChange={this.handleChange}
              />
            </Form.Item>
            <div styleName='footer'>
              <Button
                type='primary'
                htmlType='submit'
                loading={loading}
              >
                Log In
              </Button>
              <Link to='/password-recovery'><span className='fa fa-lock'/> Forgot your password?</Link>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default Login
